import Base from '@studiometa/js-toolkit';
import useResize from '@studiometa/js-toolkit/services/resize';
import Flickity from 'flickity';

/**
 * Duck punch the dragMove function in order to resolve
 * swipping bugs on iOS 13
 *
 * @see https://github.com/metafizzy/flickity/pull/1009
 */
// eslint-disable-next-line func-names
Flickity.prototype.dragMove = function (event, pointer, moveVector) {
  if (!this.isDraggable) {
    return;
  }
  event.preventDefault();

  // reverse if right-to-left
  const direction = this.options.rightToLeft ? -1 : 1;
  if (this.options.wrapAround) {
    // wrap around move. #589
    moveVector.x %= this.slideableWidth;
  }
  let dragX = this.dragStartPosition + moveVector.x * direction;

  if (!this.options.wrapAround && this.slides.length) {
    // slow drag
    const originBound = Math.max(-this.slides[0].target, this.dragStartPosition);
    dragX = dragX > originBound ? (dragX + originBound) * 0.5 : dragX;
    const endBound = Math.min(-this.getLastSlide().target, this.dragStartPosition);
    dragX = dragX < endBound ? (dragX + endBound) * 0.5 : dragX;
  }

  if (this.dragX !== dragX) {
    this.previousDragX = this.dragX;
  }

  this.dragX = dragX;

  this.dragMoveTime = new Date();
  this.dispatchEvent('dragMove', event, [pointer, moveVector]);
};

/**
 * CycleCards
 */
export default class CycleCards extends Base {
  /**
   * Config
   */
  get config() {
    return {
      name: 'CycleCards',
      refs: ['cards[]', 'panels[]', 'close[]', 'slider[]'],
    };
  }

  sliders = [];

  /**
   * Breakpoint
   */
  get breakpoint() {
    return useResize().props().breakpoint;
  }

  /**
   * Mount component
   * @return {void} [description]
   */
  mounted() {
    this.initFlickity();
  }

  /**
   * Init Flickity sliders
   * @return {void}
   */
  initFlickity() {
    if (
      !this.$options.breakpointsSlider.includes(this.breakpoint) ||
      this.$refs.cards.length <= 1
    ) {
      return;
    }

    this.$refs.slider.forEach((element, index) => {
      this.sliders[index] = new Flickity(element, {
        cellAlign: 'center',
        contain: true,
        pageDots: true,
        prevNextButtons: false,
        draggable: true,
        wrapAround: false,
      });
    });
  }

  /**
   * Destroy and reinit Flickity after tab change
   * @return {void}
   */
  reloadFlickity() {
    this.sliders.forEach((element) => {
      element.destroy();
    });

    this.initFlickity();
  }

  /**
   * Click on card and open panel
   *
   * @param  {Object} e element
   * @return {void}
   */
  onCardsClick(e) {
    const panelID = e.currentTarget.dataset.panel;

    this.currentPanel = this.$refs.panels.find((panel) => panel.id === panelID);
    this.openCurrentPanel();
  }

  /**
   * OpenCurrentPanel selected by cards
   * @return {void}
   */
  openCurrentPanel() {
    this.currentPanel.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  /**
   * Close opened panel
   * @return {void}
   */
  closeCurrentPanel() {
    document.body.style.overflow = 'auto';
    this.currentPanel.classList.remove('is-active');
    this.currentPanel = null;
  }

  /**
   * Close current panel when click on cross
   * @return {void}
   */
  onCloseClick() {
    this.closeCurrentPanel();
  }
}
